export default __webpack_public_path__ + "static/media/India 9781843629580.c27f463a.jpg";